module.exports = __webpack_public_path__ + "assets/img/efficiency.27fc551a.png";